module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray page-flex"
  }, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-input-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "alifont icon-back left-icon click",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageInfo.queryKey),
      expression: "pageInfo.queryKey"
    }],
    staticClass: "center-input fs-28",
    attrs: {
      "type": "search",
      "placeholder": "搜索订单(手机号、订单号、顾客)"
    },
    domProps: {
      "value": (_vm.pageInfo.queryKey)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.handleQuery.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pageInfo, "queryKey", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right fs-28 color-333 click",
    on: {
      "click": _vm.handleQuery
    }
  }, [_vm._v("\n            搜索\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel pd-025 pb-25"
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-refresh": _vm.loadNewData,
      "on-infinite": _vm.loadMore
    }
  }, _vm._l((_vm.data), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "card mt-20 pd-025 pt-25"
    }, [_c('div', {
      staticClass: "flex-between fs-28 font-bold"
    }, [_c('div', {
      staticClass: "color-333"
    }, [_vm._v("收货人：" + _vm._s(item.userName) + "  "), _c('span', {
      staticClass: "ml-10"
    }, [_vm._v(_vm._s(item.userMobile))])]), _vm._v(" "), _c('div', {
      class: item.orderStatus == 1 ? 'color-333' : item.orderStatus == 2 ? 'color-org' : item.orderStatus == 3 ? 'color-main' : ''
    }, [_vm._v(_vm._s(_vm.stutas[item.orderStatus]))])]), _vm._v(" "), _c('div', {
      staticClass: "color-999 fs-24 mt-8"
    }, [_vm._v("订单号：" + _vm._s(item.orderNo))]), _vm._v(" "), _c('div', {
      staticClass: "product-list"
    }, _vm._l((item.productList), function(prod, $prodIndex) {
      return _c('div', {
        staticClass: "product-item"
      }, [_c('img', {
        attrs: {
          "src": prod.imgPathView,
          "alt": ""
        }
      }), _vm._v(" "), (prod.productQty > 1) ? _c('div', {
        staticClass: "tips"
      }, [_vm._v(_vm._s(prod.productQty) + "件")]) : _vm._e()])
    }), 0), _vm._v(" "), (item.orderStatus == 2) ? _c('div', {
      staticClass: "mt-25 bd-top pd-250 flex-center"
    }, [_c('div', {
      staticClass: "item-label"
    }, [_vm._v("配送小区")]), _vm._v(" "), _c('div', {
      staticClass: "ml-10 fs-28 color-333 flex1"
    }, [_vm._v(_vm._s(item.orgName))])]) : _vm._e(), _vm._v(" "), (item.orderStatus == 3 || item.orderStatus == 1) ? _c('div', {
      staticClass: "mt-25 bd-top pd-250 flex-center"
    }, [_c('div', {
      staticClass: "item-label"
    }, [_vm._v("寄存柜")]), _vm._v(" "), _c('div', {
      staticClass: "ml-10 fs-28 color-333 flex1"
    }, [_vm._v(_vm._s(item.orderShopName))]), _vm._v(" "), _c('div', {
      staticClass: "color-org fs-28"
    }, [_vm._v("货道 " + _vm._s(item.wayCode))])]) : _vm._e(), _vm._v(" "), (item.orderStatus == 3 || item.orderStatus == 1) ? _c('div', {
      staticClass: "bd-top pd-250 flex-between fs-28 color-333"
    }, [_c('div', [_vm._v("补货人：" + _vm._s(item.linkName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.operateTime))])]) : _vm._e()])
  }), 0)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327f7a80","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/locker/lockerOrderSearch.vue
// module id = OqOX
// module chunks = 51